<style lang="less" scoped>
.space-around {
  justify-content: space-around;
}
.detail-content-body-div {
  & > div {
    margin: 0 0 50px;
  }
}
.finance-report-child-div {
  width: 232px;
  height: 245px;
  margin-top: 10px;
  background: #ffffff;
  box-shadow: 0px -1px 16px 0px rgba(42, 42, 68, 0.1);
  border-radius: 22px;
}
.report-header-div {
  margin: 20px 30px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #8f9bb3;
  line-height: 16px;
  // border-bottom: solid 1px;
}
.report-mes-div {
  margin-bottom: 20px;
  padding: 20px 22px 0;
  p {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 32px;
  }
}
.operate-condition {
  border: 2px solid #eaeaea;
  border-radius: 8px;
  & > div:first-child {
    height: 67px;
    background: #fafafa;
    padding: 0 15px;
    align-items: center;
    & > div:first-child {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #9b9b9b;
      line-height: 25px;
    }
  }
  & > div:nth-child(2) {
    padding: 0 15px 20px;
  }
}
.report-btn {
  width: 100px;
  height: 30px;
}
.line-title {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 28px;
  padding-top: 50px;
}
.report-table {
  font-family: verdana, arial, sans-serif;
  font-size: 14px;
  color: #8f9bb3;
  border-width: 1px;
  border-color: #e8e8e8;
  border-collapse: collapse;
}
.report-table td {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #e8e8e8;
  text-align: center;
}
.line-data-tab {
  p {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #a3a9af;
    line-height: 20px;
    margin: 0 15px;
  }
  i {
    position: absolute;
    bottom: -3px;
    right: 0;
    width: 20px;
    height: 2px;
    background: linear-gradient(205deg, #b780f3 0%, #59bdff 100%);
    border-radius: 2px;
  }
}
.position-r {
  position: relative;
  font-weight: 500 !important;
  color: #000000 !important;
}
.order-tab-change {
  justify-content: flex-end;
  align-items: center;
}
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">财务报表</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <div>
          <!-- <div>财务报表</div> -->
          <div class="flex space-around">
            <div class="finance-report-child-div">
              <div class="report-header-div">提现</div>
              <div class="report-mes-div">
                <p>
                  <span class="report-mes-title">待提现金额：</span><span>{{ detailForm.unCashOutFee }}元</span>
                </p>
                <p>
                  <span class="report-mes-title">已提现金额：</span><span>{{ detailForm.cashOutedFee }}元</span>
                </p>
                <p>
                  <span class="report-mes-title">未入账金额：</span><span>{{ detailForm.uncheckFee }}元</span>
                </p>
              </div>
            </div>
            <div class="finance-report-child-div">
              <div class="report-header-div">合计订单总览</div>
              <div class="report-mes-div">
                <p>
                  <span class="report-mes-title">订单收入：</span><span>{{ detailForm.actFeeAll }}元</span>
                </p>
                <p>
                  <span class="report-mes-title">充电量：</span><span>{{ detailForm.chargeValAll }}kW·h</span>
                </p>
                <p>
                  <span class="report-mes-title">订单量：</span><span>{{ detailForm.orderCountAll }}单</span>
                </p>
              </div>
            </div>
            <div class="finance-report-child-div">
              <div class="report-header-div">桩到家订单（线上订单）</div>
              <div class="report-mes-div">
                <p>
                  <span class="report-mes-title">订单收入：</span><span>{{ detailForm.actFeeOnLine }}元</span>
                </p>
                <p>
                  <span class="report-mes-title">充电量：</span><span>{{ detailForm.chargeValOnLine }}kW·h</span>
                </p>
                <p>
                  <span class="report-mes-title">订单量：</span><span>{{ detailForm.orderCountOnLine }}单</span>
                </p>
              </div>
            </div>
            <!-- </div> -->
            <!-- <div class="flex space-around"> -->
            <div class="finance-report-child-div">
              <div class="report-header-div">客户额度</div>
              <div class="report-mes-div">
                <p>
                  <span class="report-mes-title">客户金额(已支付)：</span><span>{{ detailForm.payFee }}元</span>
                </p>
                <p>
                  <span class="report-mes-title">客户金额(未支付)：</span><span>{{ detailForm.payNoFee }}元</span>
                </p>
                <p>
                  <span class="report-mes-title">服务商度电(已使用):</span><span>{{ detailForm.elecUsed }}kW·h</span>
                </p>
                <p>
                  <span class="report-mes-title">服务商度电(未使用)：</span><span>{{ detailForm.elecUnUsed }}kW·h</span>
                </p>
              </div>
            </div>
            <div class="finance-report-child-div">
              <div class="report-header-div">平台服务费</div>
              <div class="report-mes-div">
                <p>
                  <span class="report-mes-title">服务费：</span>{{ detailForm.serviceFee }}元
                </p>
                <p>
                  <span class="report-mes-title">服务费减免（已使用）：</span><span>{{ detailForm.serviceFreeFee }}元</span>
                </p>
                <p>
                  <span class="report-mes-title">服务费减免（未使用）：</span><span>{{ detailForm.serviceUnFreeFee }}元</span>
                </p>
                <p>
                  <span class="report-mes-title">桩到度电(已使用) ：</span><span>{{ detailForm.elecUsedZdj }}kW·h</span>
                </p>
                <p>
                  <span class="report-mes-title">桩到度电(未使用) ：</span><span>{{ detailForm.elecUnUsedZdj }}kW·h</span>
                </p>
              </div>
            </div>
            <div class="finance-report-child-div">
              <div class="report-header-div">自营订单（线下订单）</div>
              <div class="report-mes-div">
                <p>
                  <span class="report-mes-title">订单收入：</span><span>{{ detailForm.actFeeOffLine }}元</span>
                </p>
                <p>
                  <span class="report-mes-title">充电量：</span><span>{{ detailForm.chargeValOffLine }}kW·h</span>
                </p>
                <p>
                  <span class="report-mes-title">订单量：</span><span>{{ detailForm.orderCountOffLine }}单</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="operate-condition">
          <div class="flex"
               style="margin-bottom:10px;line-height:30px;">
            <div>经营状况</div>
            <div class="flex-1"></div>
            <div class="flex">
              <el-select v-model="tableTime"
                         size="small"
                         placeholder="请选择"
                         @change="chooseTime(tableTime)">
                <el-option label="近七日"
                           value="01"></el-option>
                <el-option label="本月"
                           value="02"></el-option>
                <el-option label="本年度"
                           value="03"></el-option>
              </el-select>
            </div>
          </div>
          <div>
            <table class="report-table"
                   width="100%">
              <tr>
                <td></td>
                <td>合计订单（元）</td>
                <td>桩到家订单（元）</td>
                <td>自营订单（元）</td>
                <td>充电量（kW·h)</td>
                <td>用户量（人）</td>
                <td>订单量（单）</td>
                <td>服务费（元）</td>
                <td>实际收入（元）</td>
              </tr>
              <tr>
                <td>本期</td>
                <td>{{ thisData.actFeeAll }}</td>
                <td>{{ thisData.actFeeOnLine }}</td>
                <td>{{ thisData.actFeeOffLine }}</td>
                <td>{{ thisData.chargeValAll }}</td>
                <td>{{ thisData.custCount }}</td>
                <td>{{ thisData.orderCountAll }}</td>
                <td>{{ thisData.serviceFeeAll }}</td>
                <td>{{ thisData.actInComeAll }}</td>
              </tr>
              <tr>
                <td>上期</td>
                <td>{{ lastData.actFeeAll }}</td>
                <td>{{ lastData.actFeeOnLine }}</td>
                <td>{{ lastData.actFeeOffLine }}</td>
                <td>{{ lastData.chargeValAll }}</td>
                <td>{{ lastData.custCount }}</td>
                <td>{{ lastData.orderCountAll }}</td>
                <td>{{ lastData.serviceFeeAll }}</td>
                <td>{{ lastData.actInComeAll }}</td>
              </tr>
              <tr>
                <td>变化趋势</td>
                <td>{{ trendData.actFeeAll }}%</td>
                <td>{{ trendData.actFeeOnLine }}%</td>
                <td>{{ trendData.actFeeOffLine }}%</td>
                <td>{{ trendData.chargeValAll }}%</td>
                <td>{{ trendData.custCount }}%</td>
                <td>{{ trendData.orderCountAll }}%</td>
                <td>{{ trendData.serviceFeeAll }}%</td>
                <td>{{ trendData.actInComeAll }}%</td>
              </tr>
            </table>
          </div>
        </div>
        <div>
          <div class="flex order-tab-change">
            <el-radio-group v-model="lineData.sourseType"
                            style="margin-right:10px;">
              <el-radio v-for="(item, index) in sourseTypeArr"
                        :label="item.value"
                        :key="index"
                        @click.native="getLineData(item)">{{ item.name }}</el-radio>
            </el-radio-group>
            <div class="flex line-data-tab">
              <p class="position-r"
                 @click="getOtherLineData(7)">
                <span>近七日</span>
                <i class="tab-unline"
                   v-if="lineChartType == '7'"></i>
              </p>
              <p class="position-r"
                 @click="getOtherLineData(30)">
                <span>本月</span>
                <i class="tab-unline"
                   v-if="lineChartType == '30'"></i>
              </p>
              <p class="position-r"
                 @click="getOtherLineData(365)">
                <span>本年度</span>
                <i class="tab-unline"
                   v-if="lineChartType == '365'"></i>
              </p>
            </div>
          </div>
          <div class="flex-1">
            <div class="line-title">
              {{ lineTitle }}订单金额<br /><br />{{ feeSum }}元
            </div>
          </div>
          <div class="flex">
            <echarts-line v-if="otherFlag"
                          :lineId="orderAmount"
                          :yUnit="unit.yuan"
                          :data="orderFee"></echarts-line>
          </div>
          <!-- <div class="flex">
                            <el-button class="report-btn" size="small" @click="getOtherLineData(7)">近七日</el-button>
                            <el-button class="report-btn" size="small" @click="getOtherLineData(30)">本月</el-button>
                            <el-button class="report-btn" size="small" @click="getOtherLineData(365)">本年度</el-button>
                        </div> -->
          <div class="flex-1">
            <div class="line-title">
              {{ lineTitle }}充电量<br /><br />{{ chargeNum }}kW
            </div>
          </div>
          <div class="flex">
            <echarts-line v-if="otherFlag"
                          :lineId="chargingCapacity"
                          :yUnit="unit.kW"
                          :data="chargeSum"></echarts-line>
          </div>
          <!-- <div class="flex">
                            <el-select v-model="lineData.sourseType" placeholder="请选择" size="small" style="margin-right:10px;">
                                <el-option label="合计订单"  value="00"></el-option>
                                <el-option label="桩到家订单（线上订单）" value="02"></el-option>
                                <el-option label="自营订单（线下订单）" value="01"></el-option>
                            </el-select>
                            <el-button class="report-btn" size="small" @click="getOtherLineData(7)">近七日</el-button>
                            <el-button class="report-btn" size="small" @click="getOtherLineData(30)">本月</el-button>
                            <el-button class="report-btn" size="small" @click="getOtherLineData(365)">本年度</el-button>
                        </div> -->
          <div class="flex-1">
            <div class="line-title">
              {{ lineTitle }}订单量<br /><br />{{ orderSum }}单
            </div>
          </div>
          <div class="flex">
            <echarts-line v-if="otherFlag"
                          :lineId="orderQuantity"
                          :yUnit="unit.dan"
                          :data="orderNum"></echarts-line>
          </div>
          <!-- <div class="flex">
                            <el-button class="report-btn" size="small" @click="getCustLineData(0)">近七日</el-button>
                            <el-button class="report-btn" size="small" @click="getCustLineData(1)">本月</el-button>
                            <el-button class="report-btn" size="small" @click="getCustLineData(2)">本年度</el-button>
                        </div> -->
          <div class="flex-1">
            <div class="line-title">
              {{ custLineTitle }}充电用户<br /><br />{{ custSum }}人
            </div>
          </div>
          <div class="flex">
            <echarts-line v-if="otherFlag"
                          :lineId="chargingUser"
                          :yUnit="unit.ren"
                          :data="custNum"></echarts-line>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
import echartsLine from './echarts-line'
export default {
  components: {
    echartsLine,
  },
  data () {
    return {
      pageConfig,
      editFlag: false,
      // 默认值设置
      detailForm: {},
      lineTitle: '近七日',      // 折线图标题
      custLineTitle: '近七日',//	 最后一个折线图日期
      orderAmount: 'orderAmount',// 折线图id
      tableTime: '01',			//默认经营状况数据
      lineChartType: '7',		//	默认折线图日期选择
      chargingCapacity: 'chargingCapacity',//折线图id
      orderQuantity: 'orderQuantity',//折线图id
      chargingUser: 'chargingUser',//折线图id
      unit: {                        //单位
        yuan: '元',
        kW: 'kW',
        dan: '单',
        ren: '人'
      },
      orderFee: {			//	存储折线图对应id的数据
        xAxis: [],
        thisData: [],
        lastData: []
      },
      chargeSum: {
        xAxis: [],
        thisData: [],
        lastData: []
      },
      orderNum: {
        xAxis: [],
        thisData: [],
        lastData: []
      },
      custNum: {
        xAxis: [],
        thisData: [],
        lastData: []
      },
      flag: true,	//			未使用(该功能已注销)
      otherFlag: false,//		控制折线图的显示
      lineData: {			//	默认折线图的经营日期
        sourseType: "00"
      },
      detailTableData: {},//	总的经营状况数据
      lastData: {},		//	上期经营表格数据
      thisData: {},   	//		本期经营表格数据
      trendData: {},		//	经营状况变化趋势
      sourseTypeArr: [	//	经营状况下拉框数据
        {
          name: '合计订单',
          value: '00'
        },
        {
          name: '桩到家订单（线上订单）',
          value: '02'
        }, {
          name: '自营订单（线下订单）',
          value: '01'
        }],
      feeSum: 0,         // 订单金额
      chargeNum: 0,	//	充电量
      orderSum: 0,	//		订单量
      custSum: 0		//	充电用户数量
    }
  },
  methods: {
    init () {
      this.getFormInfo()
      //this.getCustLineData(0);
      //默认请求7日内的数据
      this.getOtherLineData(7)
    },
    // 获取表单信息
    getFormInfo () {
      let _ = this
      let obj = {}
      // obj.dealerNo = _.$store.state.editId;//'DEAL1543895439624'
      _.$U.showLoading(_)
      _.$H.post(_, _.$A.dealer.rpt, obj).then((res) => {
        _.detailForm = res.data.data
        _.detailForm.unCashOutFee = _.detailForm.unCashOutFee.toFixed(2)
        _.detailForm.uncheckFee = _.detailForm.uncheckFee.toFixed(2)
        _.detailForm.actFeeAll = _.detailForm.actFeeAll.toFixed(2)
        _.detailForm.chargeValAll = _.detailForm.chargeValAll.toFixed(2)
        _.detailForm.orderCountAll = _.detailForm.orderCountAll.toFixed(2)
        _.detailForm.actFeeOnLine = _.detailForm.actFeeOnLine.toFixed(2)
        _.detailForm.chargeValOnLine = _.detailForm.chargeValOnLine.toFixed(2)
        _.detailForm.orderCountOnLine = _.detailForm.orderCountOnLine.toFixed(2)
        _.detailForm.custConsume = _.detailForm.custConsume.toFixed(2)
        _.detailForm.custBalance = _.detailForm.custBalance.toFixed(2)
        _.detailForm.custChargeMoney = _.detailForm.custChargeMoney.toFixed(2)
        _.detailForm.serviceFee = _.detailForm.serviceFee.toFixed(2)
        _.detailForm.serviceFreeFee = _.detailForm.serviceFreeFee.toFixed(2)
        _.detailForm.serviceUnFreeFee = _.detailForm.serviceUnFreeFee.toFixed(2)
        _.detailForm.actFeeOffLine = _.detailForm.actFeeOffLine.toFixed(2)
        _.detailForm.chargeValOffLine = _.detailForm.chargeValOffLine.toFixed(2)
        _.detailForm.orderCountOffLine = _.detailForm.orderCountOffLine.toFixed(
          2
        )
        _.$U.hideLoading(_)
      })
      _.$H.post(_, _.$A.dealer.rptform, obj).then((res) => {
        _.detailTableData = res.data.data
        _.thisData = _.detailTableData.data7Day.thisData
        _.lastData = _.detailTableData.data7Day.lastData
        _.trendData = _.detailTableData.data7Day.trendData
        _.$U.hideLoading(_)
      })
    },
    //选择经营状况
    chooseTime (timeType) {
      if (timeType == '01') {
        this.getDayTableData()
      } else if (timeType == '02') {
        this.getMonthTableData()
      } else {
        this.getAllTableData()
      }
    },
    //获取表格7日内经营状况
    getDayTableData () {
      let _ = this
      _.thisData = _.detailTableData.data7Day.thisData
      _.lastData = _.detailTableData.data7Day.lastData
      _.trendData = _.detailTableData.data7Day.trendData
    },
    //获取表格本月数据经营状况
    getMonthTableData () {
      let _ = this
      _.thisData = _.detailTableData.dataMonth.thisData
      _.lastData = _.detailTableData.dataMonth.lastData
      _.trendData = _.detailTableData.dataMonth.trendData
    },
    //获取表格本年底数据经营状况
    getAllTableData () {
      let _ = this
      _.thisData = _.detailTableData.dataAll.thisData
      _.lastData = _.detailTableData.dataAll.lastData
      _.trendData = _.detailTableData.dataAll.trendData
    },
    //选择经营状况Echart数据
    getOtherLineData (chartDateType) {
      let _ = this
      _.lineChartType = chartDateType
      if (chartDateType == 7) {
        _.lineTitle = '近七日'
        //_.lineData.dealerNo = _.$store.state.editId; //'DEAL1543895439624'
        _.lineData.chartDateType = chartDateType
        _.$U.showLoading(_)
        _.otherFlag = false
        _.orderFee.thisData = []
        _.chargeSum.thisData = []
        _.orderNum.thisData = []
        _.orderFee.xAxis = []
        _.chargeSum.xAxis = []
        _.orderNum.xAxis = []
        _.orderFee.lastData = []
        _.chargeSum.lastData = []
        _.orderNum.lastData = []
        _.custNum.thisData = []
        _.custNum.xAxis = []
        _.custNum.lastData = []
        _.feeSum = ''
        _.chargeNum = ''
        _.orderSum = ''
        _.custSum = ''
        _.$H.post(_, _.$A.dealer.rptchart, _.lineData).then((res) => {
          _.feeSum = res.data.data.feeSum
          _.chargeNum = res.data.data.chargeSum
          _.orderSum = res.data.data.orderNum
          _.custSum = res.data.data.custNum
          res.data.data.rptChartMap.thisData.forEach((item, index) => {
            _.orderFee.thisData.push(item.actFee)
            _.orderFee.xAxis.push(item.chargeDay)
            _.chargeSum.thisData.push(item.chargeVal)
            _.chargeSum.xAxis.push(item.chargeDay)
            _.orderNum.thisData.push(item.orderCount)
            _.orderNum.xAxis.push(item.chargeDay)
            _.custNum.thisData.push(item.custCount)
            _.custNum.xAxis.push(item.chargeDay)
          })
          res.data.data.rptChartMap.lastData.forEach((item, index) => {
            _.orderFee.lastData.push(item.actFee)
            _.chargeSum.lastData.push(item.chargeVal)
            _.orderNum.lastData.push(item.orderCount)
            _.custNum.lastData.push(item.custCount)
          })
          setTimeout(function () {
            _.otherFlag = true
          }, 400)
          _.$U.hideLoading(_)
        })
      } else if (chartDateType == 30) {
        _.lineTitle = '本月'
        //_.lineData.dealerNo = _.$store.state.editId; //'DEAL1543895439624'
        _.lineData.chartDateType = chartDateType
        _.$U.showLoading(_)
        _.otherFlag = false
        _.orderFee.thisData = []
        _.chargeSum.thisData = []
        _.orderNum.thisData = []
        _.orderFee.xAxis = [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
        ]
        _.chargeSum.xAxis = [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
        ]
        _.orderNum.xAxis = [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
        ]
        _.orderFee.lastData = []
        _.chargeSum.lastData = []
        _.orderNum.lastData = []
        _.custNum.thisData = []
        _.custNum.xAxis = [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
        ]
        _.custNum.lastData = []
        _.feeSum = ''
        _.chargeNum = ''
        _.orderSum = ''
        _.custSum = ''
        _.$H.post(_, _.$A.dealer.rptchart, _.lineData).then((res) => {
          _.feeSum = res.data.data.feeSum
          _.chargeNum = res.data.data.chargeSum
          _.orderSum = res.data.data.orderNum
          _.custSum = res.data.data.custNum
          res.data.data.rptChartMap.thisData.forEach((item, index) => {
            _.orderFee.thisData.push(item.actFee)
            //_.orderFee.xAxis = ;
            _.chargeSum.thisData.push(item.chargeVal)
            //_.chargeSum.xAxis.push(item.chargeDay);
            _.orderNum.thisData.push(item.orderCount)
            //_.orderNum.xAxis.push(item.chargeDay);
            _.custNum.thisData.push(item.custCount)
            //_.custNum.xAxis.push(item.chargeDay);
          })
          res.data.data.rptChartMap.lastData.forEach((item, index) => {
            _.orderFee.lastData.push(item.actFee)
            _.chargeSum.lastData.push(item.chargeVal)
            _.orderNum.lastData.push(item.orderCount)
            _.custNum.lastData.push(item.custCount)
          })
          setTimeout(function () {
            _.otherFlag = true
          }, 400)
          _.$U.hideLoading(_)
        })
      } else {
        _.lineTitle = '本年度'
        //_.lineData.dealerNo = _.$store.state.editId; //'DEAL1543895439624'
        _.lineData.chartDateType = chartDateType
        _.$U.showLoading(_)
        _.otherFlag = false
        _.orderFee.thisData = []
        _.chargeSum.thisData = []
        _.orderNum.thisData = []
        _.orderFee.xAxis = [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ]
        _.chargeSum.xAxis = [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ]
        _.orderNum.xAxis = [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ]
        _.orderFee.lastData = []
        _.chargeSum.lastData = []
        _.orderNum.lastData = []
        _.custNum.thisData = []
        _.custNum.xAxis = [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ]
        _.custNum.lastData = []
        _.feeSum = ''
        _.chargeNum = ''
        _.orderSum = ''
        _.custSum = ''
        _.$H.post(_, _.$A.dealer.rptchart, _.lineData).then((res) => {
          _.feeSum = res.data.data.feeSum
          _.chargeNum = res.data.data.chargeSum
          _.orderSum = res.data.data.orderNum
          _.custSum = res.data.data.custNum
          res.data.data.rptChartMap.thisData.forEach((item, index) => {
            _.orderFee.thisData.push(item.actFee)
            //_.orderFee.xAxis.push(item.chargeDay);
            _.chargeSum.thisData.push(item.chargeVal)
            //_.chargeSum.xAxis.push(item.chargeDay);
            _.orderNum.thisData.push(item.orderCount)
            //_.orderNum.xAxis.push(item.chargeDay);
            _.custNum.thisData.push(item.custCount)
            //_.custNum.xAxis.push(item.chargeDay);
          })
          res.data.data.rptChartMap.lastData.forEach((item, index) => {
            _.orderFee.lastData.push(item.actFee)
            _.chargeSum.lastData.push(item.chargeVal)
            _.orderNum.lastData.push(item.orderCount)
            _.custNum.lastData.push(item.custCount)
          })
          setTimeout(function () {
            _.otherFlag = true
          }, 400)
          _.$U.hideLoading(_)
        })
      }
    },
    //选择合计订单  线上订单  线下订单
    getLineData (val) {
      let _ = this
      _.lineData.sourseType = val.value
      if (_.lineData.chartDateType == 7) {
        _.lineTitle = '近七日'
        //_.lineData.dealerNo = _.$store.state.editId; //'DEAL1543895439624'
        //_.lineData.chartDateType = chartDateType;
        _.$U.showLoading(_)
        _.otherFlag = false
        _.orderFee.thisData = []
        _.chargeSum.thisData = []
        _.orderNum.thisData = []
        _.orderFee.xAxis = []
        _.chargeSum.xAxis = []
        _.orderNum.xAxis = []
        _.orderFee.lastData = []
        _.chargeSum.lastData = []
        _.orderNum.lastData = []
        _.custNum.thisData = []
        _.custNum.xAxis = []
        _.custNum.lastData = []
        _.feeSum = ''
        _.chargeNum = ''
        _.orderSum = ''
        _.custSum = ''
        _.$H.post(_, _.$A.dealer.rptchart, _.lineData).then((res) => {
          _.feeSum = res.data.data.feeSum
          _.chargeNum = res.data.data.chargeSum
          _.orderSum = res.data.data.orderNum
          _.custSum = res.data.data.custNum
          res.data.data.rptChartMap.thisData.forEach((item, index) => {
            _.orderFee.thisData.push(item.actFee)
            _.orderFee.xAxis.push(item.chargeDay)
            _.chargeSum.thisData.push(item.chargeVal)
            _.chargeSum.xAxis.push(item.chargeDay)
            _.orderNum.thisData.push(item.orderCount)
            _.orderNum.xAxis.push(item.chargeDay)
            _.custNum.thisData.push(item.custCount)
            _.custNum.xAxis.push(item.chargeDay)
          })
          res.data.data.rptChartMap.lastData.forEach((item, index) => {
            _.orderFee.lastData.push(item.actFee)
            _.chargeSum.lastData.push(item.chargeVal)
            _.orderNum.lastData.push(item.orderCount)
            _.custNum.lastData.push(item.custCount)
          })
          setTimeout(function () {
            _.otherFlag = true
          }, 400)
          _.$U.hideLoading(_)
        })
      } else if (_.lineData.chartDateType == 30) {
        _.lineTitle = '本月'
        //_.lineData.dealerNo = _.$store.state.editId; //'DEAL1543895439624'
        //_.lineData.chartDateType = chartDateType;
        _.$U.showLoading(_)
        _.otherFlag = false
        _.orderFee.thisData = []
        _.chargeSum.thisData = []
        _.orderNum.thisData = []
        _.orderFee.xAxis = [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
        ]
        _.chargeSum.xAxis = [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
        ]
        _.orderNum.xAxis = [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
        ]
        _.orderFee.lastData = []
        _.chargeSum.lastData = []
        _.orderNum.lastData = []
        _.custNum.thisData = []
        _.custNum.xAxis = [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
        ]
        _.custNum.lastData = []
        _.feeSum = ''
        _.chargeNum = ''
        _.orderSum = ''
        _.custSum = ''
        _.$H.post(_, _.$A.dealer.rptchart, _.lineData).then((res) => {
          _.feeSum = res.data.data.feeSum
          _.chargeNum = res.data.data.chargeSum
          _.orderSum = res.data.data.orderNum
          _.custSum = res.data.data.custNum
          res.data.data.rptChartMap.thisData.forEach((item, index) => {
            _.orderFee.thisData.push(item.actFee)
            //_.orderFee.xAxis = ;
            _.chargeSum.thisData.push(item.chargeVal)
            //_.chargeSum.xAxis.push(item.chargeDay);
            _.orderNum.thisData.push(item.orderCount)
            //_.orderNum.xAxis.push(item.chargeDay);
            _.custNum.thisData.push(item.custCount)
            //_.custNum.xAxis.push(item.chargeDay);
          })
          res.data.data.rptChartMap.lastData.forEach((item, index) => {
            _.orderFee.lastData.push(item.actFee)
            _.chargeSum.lastData.push(item.chargeVal)
            _.orderNum.lastData.push(item.orderCount)
            _.custNum.lastData.push(item.custCount)
          })
          setTimeout(function () {
            _.otherFlag = true
          }, 400)
          _.$U.hideLoading(_)
        })
      } else {
        _.lineTitle = '本年度'
        //_.lineData.dealerNo = _.$store.state.editId; //'DEAL1543895439624'
        //_.lineData.chartDateType = chartDateType;
        _.$U.showLoading(_)
        _.otherFlag = false
        _.orderFee.thisData = []
        _.chargeSum.thisData = []
        _.orderNum.thisData = []
        _.orderFee.xAxis = [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ]
        _.chargeSum.xAxis = [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ]
        _.orderNum.xAxis = [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ]
        _.orderFee.lastData = []
        _.chargeSum.lastData = []
        _.orderNum.lastData = []
        _.custNum.thisData = []
        _.custNum.xAxis = [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ]
        _.custNum.lastData = []
        _.feeSum = ''
        _.chargeNum = ''
        _.orderSum = ''
        _.custSum = ''
        _.$H.post(_, _.$A.dealer.rptchart, _.lineData).then((res) => {
          _.feeSum = res.data.data.feeSum
          _.chargeNum = res.data.data.chargeSum
          _.orderSum = res.data.data.orderNum
          _.custSum = res.data.data.custNum
          res.data.data.rptChartMap.thisData.forEach((item, index) => {
            _.orderFee.thisData.push(item.actFee)
            //_.orderFee.xAxis.push(item.chargeDay);
            _.chargeSum.thisData.push(item.chargeVal)
            //_.chargeSum.xAxis.push(item.chargeDay);
            _.orderNum.thisData.push(item.orderCount)
            //_.orderNum.xAxis.push(item.chargeDay);
            _.custNum.thisData.push(item.custCount)
            //_.custNum.xAxis.push(item.chargeDay);
          })
          res.data.data.rptChartMap.lastData.forEach((item, index) => {
            _.orderFee.lastData.push(item.actFee)
            _.chargeSum.lastData.push(item.chargeVal)
            _.orderNum.lastData.push(item.orderCount)
            _.custNum.lastData.push(item.custCount)
          })
          setTimeout(function () {
            _.otherFlag = true
          }, 400)
          _.$U.hideLoading(_)
        })
      }
    },
    //已注销该功能
    getCustLineData (timeType) {
      let _ = this
      if (timeType == 0) {
        _.custLineTitle = '近七日'
      } else if (timeType == 1) {
        _.custLineTitle = '本月'
      } else {
        _.custLineTitle = '本年度'
      }
      _.custNum.xAxis = []
      _.custNum.thisData = []
      _.custNum.lastData = []
      let obj = {}
      obj.timeType = timeType
      _.flag = false
      _.$U.showLoading(_)
      _.$H.get(_, _.$A.dealer.custlinedata, obj).then((res) => {
        res.data.data.forEach((item) => {
          if (item.dayType == 0) {
            _.custNum.thisData.push(item.userCount)
          } else {
            _.custNum.lastData.push(item.userCount)
          }
        })
        if (_.custNum.thisData.length > _.custNum.lastData.length) {
          _.custNum.thisData.forEach((item, index) => {
            _.custNum.xAxis.push(index + 1 + '')
          })
        } else {
          _.custNum.lastData.forEach((item, index) => {
            _.custNum.xAxis.push(index + 1 + '')
          })
        }
        _.flag = true
        _.$U.hideLoading(_)
      })
    },
  },
  mounted () {
    this.init()
  },
}
</script>
